import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SetupPath.module.css";
import { useAgentStore } from "../../../Store/agentDetailStore";
import { fetchAgentDetailById } from "../../../Store/apiStore";
import { trackEvent } from "../../../lib/analytics";
import useBackTo from "../../../lib/useBackTo";
import AnimatedButton from "../../AnimatedButton/AnimatedButton";
import { requestDeviceCarrier } from "../../../lib/deviceCarrier";

/*
 * SetupPath — "How Customers Reach {agent}" (variant B).
 *
 * Ye screen tay karti hai ki aage kaunsa rasta chalega:
 *
 *   "Keep My Existing Business Number"  → call forwarding setup
 *                                         (Carrier → Forwarding steps → Triage)
 *   "Use {agent}'s Business Number"     → SEEDHA Call Triage
 *
 * DOBARA COMPONENT NAHI BANAYE. Carrier / Forwarding / Triage teeno pehle se
 * GoLiveWizard (/go-live-setup) me hain — wahi A flow payment ke baad use karta
 * hai. Hum sirf wizard ko batate hain ki kis step se shuru karna hai:
 *
 *   localStorage["goLiveWizard.lastStep"] = 2  → Carrier
 *   localStorage["goLiveWizard.lastStep"] = 4  → Triage
 *
 * Wizard boot pe yahi key padhta hai (GoLiveWizard.jsx ~line 274) aur wahin se
 * resume kar leta hai. Isliye A flow ka behaviour bilkul nahi badla — hum bas
 * usi wizard me alag jagah se ghuste hain.
 */

// GoLiveWizard.jsx ka STORAGE_KEY — dono jagah same hona zaroori hai.
const WIZARD_STEP_KEY = "goLiveWizard.lastStep";
// Wizard boot pe ye flag dekhta hai: na ho to B user ko wapas yahin bhej deta
// hai. Isliye rasta chunte hi set karna ZAROORI hai, warna loop ban jayega.
const SETUP_PATH_CHOSEN_KEY = "bflow.setupPathChosen";
// GoLiveWizard ke STEPS array ke ids.
const WIZARD_STEP_CARRIER = 2;
const WIZARD_STEP_TRIAGE = 4;

const KEEP_EXISTING = "existing";
const USE_AGENT_NUMBER = "agent";

const Check = () => (
    <svg width="10" height="10" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
            d="M3.5 8L6.5 11L12.5 5"
            stroke="#fff"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const PhoneIcon = () => (
    <svg width="16" height="32" viewBox="0 0 16 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.76 4.8H3.2V1.06667C3.2 0.783769 3.08762 0.512458 2.88758 0.31242C2.68754 0.112381 2.41623 0 2.13333 0H1.06667C0.783769 0 0.512457 0.112381 0.312419 0.31242C0.11238 0.512458 0 0.783769 0 1.06667V29.76C0.00140843 30.3537 0.237861 30.9226 0.657638 31.3424C1.07741 31.7621 1.64635 31.9986 2.24 32H13.76C14.3537 31.9986 14.9226 31.7621 15.3424 31.3424C15.7621 30.9226 15.9986 30.3537 16 29.76V7.04C15.9972 6.44678 15.7603 5.87865 15.3408 5.45918C14.9213 5.0397 14.3532 4.80281 13.76 4.8ZM5.33333 26C5.33333 26.0707 5.30524 26.1386 5.25523 26.1886C5.20522 26.2386 5.13739 26.2667 5.06667 26.2667H3.46667C3.39594 26.2667 3.32811 26.2386 3.2781 26.1886C3.2281 26.1386 3.2 26.0707 3.2 26V25.2C3.2 25.1293 3.2281 25.0614 3.2781 25.0114C3.32811 24.9614 3.39594 24.9333 3.46667 24.9333H5.06667C5.13739 24.9333 5.20522 24.9614 5.25523 25.0114C5.30524 25.0614 5.33333 25.1293 5.33333 25.2V26ZM5.33333 23.6C5.33333 23.6707 5.30524 23.7386 5.25523 23.7886C5.20522 23.8386 5.13739 23.8667 5.06667 23.8667H3.46667C3.39594 23.8667 3.32811 23.8386 3.2781 23.7886C3.2281 23.7386 3.2 23.6707 3.2 23.6V22.8C3.2 22.7293 3.2281 22.6614 3.2781 22.6114C3.32811 22.5614 3.39594 22.5333 3.46667 22.5333H5.06667C5.13739 22.5333 5.20522 22.5614 5.25523 22.6114C5.30524 22.6614 5.33333 22.7293 5.33333 22.8V23.6ZM5.33333 21.2C5.33333 21.2707 5.30524 21.3386 5.25523 21.3886C5.20522 21.4386 5.13739 21.4667 5.06667 21.4667H3.46667C3.39594 21.4667 3.32811 21.4386 3.2781 21.3886C3.2281 21.3386 3.2 21.2707 3.2 21.2V20.4C3.2 20.3293 3.2281 20.2614 3.2781 20.2114C3.32811 20.1614 3.39594 20.1333 3.46667 20.1333H5.06667C5.13739 20.1333 5.20522 20.1614 5.25523 20.2114C5.30524 20.2614 5.33333 20.3293 5.33333 20.4V21.2ZM9.06667 26C9.06667 26.0707 9.03857 26.1386 8.98856 26.1886C8.93855 26.2386 8.87072 26.2667 8.8 26.2667H7.2C7.12928 26.2667 7.06145 26.2386 7.01144 26.1886C6.96143 26.1386 6.93333 26.0707 6.93333 26V25.2C6.93333 25.1293 6.96143 25.0614 7.01144 25.0114C7.06145 24.9614 7.12928 24.9333 7.2 24.9333H8.8C8.87072 24.9333 8.93855 24.9614 8.98856 25.0114C9.03857 25.0614 9.06667 25.1293 9.06667 25.2V26ZM9.06667 23.6C9.06667 23.6707 9.03857 23.7386 8.98856 23.7886C8.93855 23.8386 8.87072 23.8667 8.8 23.8667H7.2C7.12928 23.8667 7.06145 23.8386 7.01144 23.7886C6.96143 23.7386 6.93333 23.6707 6.93333 23.6V22.8C6.93333 22.7293 6.96143 22.6614 7.01144 22.6114C7.06145 22.5614 7.12928 22.5333 7.2 22.5333H8.8C8.87072 22.5333 8.93855 22.5614 8.98856 22.6114C9.03857 22.6614 9.06667 22.7293 9.06667 22.8V23.6ZM9.06667 21.2C9.06667 21.2707 9.03857 21.3386 8.98856 21.3886C8.93855 21.4386 8.87072 21.4667 8.8 21.4667H7.2C7.12928 21.4667 7.06145 21.4386 7.01144 21.3886C6.96143 21.3386 6.93333 21.2707 6.93333 21.2V20.4C6.93333 20.3293 6.96143 20.2614 7.01144 20.2114C7.06145 20.1614 7.12928 20.1333 7.2 20.1333H8.8C8.87072 20.1333 8.93855 20.1614 8.98856 20.2114C9.03857 20.2614 9.06667 20.3293 9.06667 20.4V21.2ZM12.8 26C12.8 26.0707 12.7719 26.1386 12.7219 26.1886C12.6719 26.2386 12.6041 26.2667 12.5333 26.2667H10.9333C10.8626 26.2667 10.7948 26.2386 10.7448 26.1886C10.6948 26.1386 10.6667 26.0707 10.6667 26V25.2C10.6667 25.1293 10.6948 25.0614 10.7448 25.0114C10.7948 24.9614 10.8626 24.9333 10.9333 24.9333H12.5333C12.6041 24.9333 12.6719 24.9614 12.7219 25.0114C12.7719 25.0614 12.8 25.1293 12.8 25.2V26ZM12.8 23.6C12.8 23.6707 12.7719 23.7386 12.7219 23.7886C12.6719 23.8386 12.6041 23.8667 12.5333 23.8667H10.9333C10.8626 23.8667 10.7948 23.8386 10.7448 23.7886C10.6948 23.7386 10.6667 23.6707 10.6667 23.6V22.8C10.6667 22.7293 10.6948 22.6614 10.7448 22.6114C10.7948 22.5614 10.8626 22.5333 10.9333 22.5333H12.5333C12.6041 22.5333 12.6719 22.5614 12.7219 22.6114C12.7719 22.6614 12.8 22.7293 12.8 22.8V23.6ZM12.8 21.2C12.8 21.2707 12.7719 21.3386 12.7219 21.3886C12.6719 21.4386 12.6041 21.4667 12.5333 21.4667H10.9333C10.8626 21.4667 10.7948 21.4386 10.7448 21.3886C10.6948 21.3386 10.6667 21.2707 10.6667 21.2V20.4C10.6667 20.3293 10.6948 20.2614 10.7448 20.2114C10.7948 20.1614 10.8626 20.1333 10.9333 20.1333H12.5333C12.6041 20.1333 12.6719 20.1614 12.7219 20.2114C12.7719 20.2614 12.8 20.3293 12.8 20.4V21.2ZM12.8 17.0667C12.8 17.2081 12.7438 17.3438 12.6438 17.4438C12.5438 17.5438 12.4081 17.6 12.2667 17.6H3.73333C3.59188 17.6 3.45623 17.5438 3.35621 17.4438C3.25619 17.3438 3.2 17.2081 3.2 17.0667V8.53333C3.2 8.39188 3.25619 8.25623 3.35621 8.15621C3.45623 8.05619 3.59188 8 3.73333 8H12.2667C12.4081 8 12.5438 8.05619 12.6438 8.15621C12.7438 8.25623 12.8 8.39188 12.8 8.53333V17.0667Z" fill="#6524EB" />
    </svg>

);

const HeadsetIcon = () => (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.0272 20.4677L17.7889 18.9553C16.424 18.5126 14.6532 20.3202 14.6532 20.3202C11.1118 19.4717 6.57434 14.9711 5.68898 11.3928C5.68898 11.3928 7.49658 9.58521 7.05391 8.25717L5.54142 3.0188C5.39386 2.42856 4.80362 2.09655 4.21338 2.17033L3.47558 2.281C1.26219 2.6499 -0.287193 4.71574 0.0448167 6.96602C1.37285 16.4836 9.56242 24.6732 19.08 26.0012C21.2934 26.2963 23.3961 24.7839 23.765 22.5705L23.8757 21.8327C23.9495 21.2055 23.5806 20.6522 23.0272 20.4677Z" fill="#6524EB" />
        <path d="M24.7238 8.37402H22.6948V5.79172H24.7238C25.4247 5.79172 25.978 5.23837 25.978 4.53746C25.978 3.83655 25.4247 3.2832 24.7238 3.2832H22.6948V1.25426C22.6948 0.553349 22.1415 0 21.4406 0C20.7396 0 20.1863 0.553349 20.1863 1.25426V3.2832H17.5671V1.25426C17.5671 0.553349 17.0138 0 16.3129 0C15.6119 0 15.0586 0.553349 15.0586 1.25426V3.2832H13.0296C12.3287 3.2832 11.7754 3.83655 11.7754 4.53746C11.7754 5.23837 12.3287 5.79172 13.0296 5.79172H15.0586V8.37402H13.0296C12.3287 8.37402 11.7754 8.92736 11.7754 9.62827C11.7754 10.3292 12.3287 10.8825 13.0296 10.8825H15.0586V12.9115C15.0586 13.6124 15.6119 14.1657 16.3129 14.1657C17.0138 14.1657 17.5671 13.6124 17.5671 12.9115V10.8825H20.1863V12.9115C20.1863 13.6124 20.7396 14.1657 21.4406 14.1657C22.1415 14.1657 22.6948 13.6124 22.6948 12.9115V10.8825H24.7238C25.4247 10.8825 25.978 10.3292 25.978 9.62827C25.978 8.96425 25.4247 8.37402 24.7238 8.37402ZM20.1863 8.37402H17.5671V5.79172H20.1863V8.37402Z" fill="#6524EB" />
    </svg>

);

const SetupPath = () => {
    const navigate = useNavigate();
    const { agentData } = useAgentStore();
    const [fetchedName, setFetchedName] = useState("");
    // User ko khud path select karna hoga; koi option default selected nahi hai.
    const [choice, setChoice] = useState(null);

    const agentId = sessionStorage.getItem("SelectAgentId") || "";
    const agentName = (
        fetchedName ||
        agentData?.agent?.agentName ||
        "Sophia"
    ).trim();

    useEffect(() => {
        trackEvent("b_flow_setup_path_view", { screen: "setup_path" });
    }, []);

    /*
     * Back → /fast-agent-detail.
     *
     * Peeche checkout / wizard hai jahan wapas jaana nuksaan karta hai (payment
     * ho chuka, number assign ho chuka). User yahan se nikalna chahta hai to
     * usse apne agent ke home pe bhej do.
     */
    useBackTo("/fast-agent-detail");

    // Store khaali ho sakta hai (reload / seedha yahan aana) — naam sahi dikhe.
    useEffect(() => {
        if (!agentId || agentData?.agent?.agentName) return undefined;
        let cancelled = false;
        (async () => {
            try {
                const res = await fetchAgentDetailById({
                    agentId,
                    bussinesId: sessionStorage.getItem("SelectAgentBusinessId"),
                });
                if (!cancelled && res?.data?.agent?.agentName) {
                    setFetchedName(res.data.agent.agentName);
                }
            } catch (err) {
                console.error("[SetupPath] agent name fetch failed:", err);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [agentId, agentData?.agent?.agentName]);

    const handleContinue = () => {
        if (!choice) return;

        const keepExisting = choice === KEEP_EXISTING;
        trackEvent("b_flow_setup_path_chosen", {
            screen: "setup_path",
            path: keepExisting ? "keep_existing_number" : "use_agent_number",
        });

        // Wizard ko batao kahan se shuru karna hai. localStorage isliye (session
        // nahi) kyunki wizard bhi wahin se padhta hai.
        try {
            localStorage.setItem(
                WIZARD_STEP_KEY,
                String(keepExisting ? WIZARD_STEP_CARRIER : WIZARD_STEP_TRIAGE)
            );
            // Ye flag pehle set karo — bina iske wizard boot pe wapas yahin
            // bhej dega aur user do screens ke beech ghoomta rahega.
            localStorage.setItem(SETUP_PATH_CHOSEN_KEY, "true");
        } catch {
            /* storage blocked — wizard step 1 se shuru ho jayega, toota kuch nahi */
        }

        /*
         * Call-forwarding wale raste pe hi carrier chahiye — native shell se
         * device ka carrier maang lete hain taaki agli screen pe user ko wo
         * pehle se chuna hua mile.
         *
         * Jawab ka intezaar nahi karte: native "message" event me baad me
         * bhejta hai aur wo sessionStorage me chala jaata hai. Carrier screen
         * mount hote waqt use padh leti hai. Web pe ye chup-chaap no-op hai.
         */
        if (keepExisting) requestDeviceCarrier();

        // agentId URL me bhi bhej dete hain: cold WebView me session khaali ho
        // sakta hai aur wizard tab query se hi agent uthata hai.
        navigate(agentId ? `/go-live-setup?agentId=${agentId}` : "/go-live-setup");
    };

    const options = [
        {
            id: KEEP_EXISTING,
            Icon: PhoneIcon,
            title: "Keep My Existing Business Number",
            sub: " Keep the number your customers already know.",
            bullets: [
                "Customers keep calling your current number",
                "No need to update your website or listings",
                "Requires call forwarding setup",
            ],
        },
        {
            id: USE_AGENT_NUMBER,
            Icon: HeadsetIcon,
            title: `Use ${agentName}'s Business Number`,
            sub: `Publish ${agentName}'s number on your website, ads, or business listings and receive calls directly.`,
            bullets: [
                "No call forwarding needed",
                `Calls go direct to ${agentName}`,
                "Great for new numbers, ads, and local campaigns",
            ],
        },
    ];

    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                {/* Do lines, do weights — "How Customers" halka, "Reach {naam}?"
                    bold. Naam yahin par hai isliye bold wali line ke saath
                    rakha hai, warna emphasis bat jaata. */}
                <h1 className={styles.title}>
                    <span className={styles.titleLight}>How Customers</span>
                    <span className={styles.titleBold}>Reach {agentName}?</span>
                </h1>
                <p className={styles.sub}>
                    Choose which number you want to use for customer calls.
                </p>

                <div className={styles.options} role="radiogroup" aria-label="Setup path">
                    {options.map((opt) => {
                        const picked = choice === opt.id;
                        const { Icon } = opt;
                        return (
                            <button
                                key={opt.id}
                                type="button"
                                role="radio"
                                aria-checked={picked}
                                onClick={() => setChoice(opt.id)}
                                className={`${styles.option} ${picked ? styles.optionSelected : ""}`}
                            >
                                <span className={styles.optionHead}>
                                    <span className={styles.optionIcon}>
                                        <Icon />
                                    </span>
                                    <span className={styles.optionTitleWrap}>
                                        <span className={styles.optionTitle}>{opt.title}</span>
                                        <span className={styles.optionSub}>{opt.sub}</span>
                                    </span>
                                    <span
                                        className={`${styles.radio} ${picked ? styles.radioPicked : ""}`}
                                        aria-hidden="true"
                                    />
                                </span>

                                <ul className={styles.bullets}>
                                    {opt.bullets.map((b) => (
                                        <li key={b} className={styles.bullet}>
                                            <span className={styles.bulletCheck}>
                                                <Check />
                                            </span>
                                            <span>{b}</span>
                                        </li>
                                    ))}
                                </ul>
                            </button>
                        );
                    })}
                </div>

                <p className={styles.tip}>
                    <span className={styles.tipIcon} role="img" aria-label="Tip"><svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.2917 16.2159C13.1364 17.3713 13.2808 19.7026 13.2808 19.7026H7.42165C7.42165 19.7026 7.54544 17.3713 6.41074 16.2159C5.15226 15.1019 4.34766 13.4927 4.34766 11.6978C4.34766 8.39685 7.02967 5.71484 10.3306 5.71484C13.6315 5.71484 16.3135 8.39685 16.3135 11.6978C16.3135 13.4927 15.5296 15.1019 14.2917 16.2159Z" fill="#FFD517" />
                        <path d="M13.4462 21.5375C13.4462 21.847 13.1986 22.0945 12.8892 22.0945H7.79336C7.4839 22.0945 7.23633 21.847 7.23633 21.5375C7.23633 21.228 7.4839 20.9805 7.79336 20.9805H12.8685C13.178 20.9805 13.4462 21.228 13.4462 21.5375ZM12.6829 23.8482C12.6829 24.1576 12.4353 24.4052 12.1258 24.4052H8.5567C8.24724 24.4052 7.99967 24.1576 7.99967 23.8482C7.99967 23.5387 8.24724 23.2911 8.5567 23.2911H12.1258C12.4353 23.2911 12.6829 23.5387 12.6829 23.8482Z" fill="#E5E5E5" />
                        <path d="M14.6016 16.4236C15.9426 15.2064 16.7059 13.494 16.7059 11.6992C16.7059 8.19191 13.8382 5.32422 10.331 5.32422C6.82374 5.32422 3.95605 8.19191 3.95605 11.6992C3.95605 13.5353 4.76066 15.2889 6.12229 16.4855C7.13321 17.4964 7.03005 19.642 7.03005 19.6627C7.03005 19.7658 7.07131 19.869 7.13321 19.9515C7.21573 20.034 7.31888 20.0753 7.42204 20.0753H13.2606C13.3637 20.0753 13.4669 20.034 13.5494 19.9515C13.6319 19.869 13.6526 19.7658 13.6526 19.6627C13.6526 19.642 13.5494 17.4964 14.5603 16.4855C14.5809 16.4649 14.6016 16.4442 14.6016 16.4236ZM14.0239 15.9078C13.9826 15.9285 13.962 15.9697 13.9414 16.011C13.0336 16.9806 12.8892 18.5692 12.8686 19.3119H7.81402C7.79339 18.5486 7.62835 16.8981 6.6587 15.9285C5.44148 14.8557 4.74003 13.329 4.74003 11.7198C4.74003 8.62515 7.25699 6.12882 10.331 6.12882C13.4256 6.12882 15.9219 8.64579 15.9219 11.7198C15.9219 13.3084 15.2411 14.8557 14.0239 15.9078Z" fill="#210B20" />
                        <path d="M10.3307 6.97323C10.1243 6.97323 9.93867 7.13827 9.93867 7.36521C9.93867 7.57152 10.1037 7.7572 10.3307 7.7572C12.6413 7.7572 14.5187 9.63461 14.5187 11.9453C14.5187 12.1516 14.6838 12.3372 14.9107 12.3372C15.117 12.3372 15.3027 12.1722 15.3027 11.9453C15.3027 9.20136 13.0746 6.97323 10.3307 6.97323ZM13.8379 21.5386C13.8379 21.0022 13.4047 20.5896 12.8889 20.5896H7.79306C7.25666 20.5896 6.84404 21.0228 6.84404 21.5386C6.84404 22.075 7.27729 22.4876 7.79306 22.4876H12.8682C13.4047 22.4876 13.8379 22.075 13.8379 21.5386ZM12.8682 21.7036H7.79306C7.68991 21.7036 7.62802 21.6211 7.62802 21.5386C7.62802 21.4354 7.71054 21.3736 7.79306 21.3736H12.8682C12.9714 21.3736 13.0333 21.4561 13.0333 21.5386C13.0539 21.6418 12.9714 21.7036 12.8682 21.7036ZM12.1255 22.9002H8.5564C8.02 22.9002 7.60738 23.3335 7.60738 23.8493C7.60738 24.3857 8.04063 24.7983 8.5564 24.7983H12.1255C12.6619 24.7983 13.0746 24.365 13.0746 23.8493C13.0746 23.3335 12.6413 22.9002 12.1255 22.9002ZM12.1255 24.0143H8.5564C8.45325 24.0143 8.39136 23.9318 8.39136 23.8493C8.39136 23.7461 8.47388 23.6842 8.5564 23.6842H12.1255C12.2287 23.6842 12.2906 23.7667 12.2906 23.8493C12.2906 23.9524 12.2287 24.0143 12.1255 24.0143ZM10.7226 3.03273V0.391986C10.7226 0.185678 10.5576 0 10.3307 0C10.1243 0 9.93867 0.165047 9.93867 0.391986V3.05337C9.93867 3.25967 10.1037 3.44535 10.3307 3.44535C10.5576 3.42472 10.7226 3.25967 10.7226 3.03273ZM16.8294 1.95993C16.6437 1.83615 16.4168 1.89804 16.293 2.06308L14.8282 4.27059C14.7044 4.45626 14.7663 4.6832 14.9313 4.80699C14.9932 4.84825 15.0758 4.86888 15.1376 4.86888C15.2614 4.86888 15.3852 4.80699 15.4677 4.70383L16.9325 2.49633C17.0563 2.33129 16.9944 2.08372 16.8294 1.95993ZM5.66808 4.78636C5.72998 4.78636 5.8125 4.76573 5.87439 4.72446C6.06007 4.60068 6.10133 4.37374 5.99818 4.18806L4.57465 1.95993C4.45086 1.77425 4.22393 1.73299 4.03825 1.83615C3.85257 1.95993 3.81131 2.18687 3.91446 2.37255L5.33799 4.60068C5.42051 4.72446 5.5443 4.78636 5.66808 4.78636ZM0.20091 6.64313L2.5322 7.90161C2.59409 7.94288 2.65598 7.94288 2.71787 7.94288C2.86229 7.94288 2.98607 7.86035 3.0686 7.73657C3.17175 7.55089 3.10986 7.30332 2.90355 7.20017L0.572266 5.94168C0.386588 5.83853 0.139018 5.90042 0.0358637 6.10673C-0.0466596 6.31304 0.0152328 6.53998 0.20091 6.64313ZM17.9434 7.96351C18.0053 7.96351 18.0672 7.94288 18.1291 7.92225L20.4604 6.66376C20.6461 6.56061 20.7286 6.33367 20.6254 6.12736C20.5223 5.94168 20.2954 5.85916 20.089 5.96231L17.7578 7.2208C17.5721 7.32395 17.4896 7.55089 17.5927 7.7572C17.6546 7.88098 17.799 7.96351 17.9434 7.96351Z" fill="#210B20" />
                    </svg>
                    </span>
                    <span><strong>Tip:</strong> You can change this later.</span>
                </p>
            </div>

            <div className={styles.footer}>
                <AnimatedButton
                    label="Continue ->"
                    onClick={handleContinue}
                    disabled={!choice}
                    positionType="relative"
                    width="100%"
                    bottom="0"
                />
                {choice && <p className={styles.footerNote}>
            <strong>Next:</strong>{" "}
            {choice === KEEP_EXISTING
                ? "Set up call forwarding"
                : "Set up call triage"}
        </p>}
            </div>
        </div>
    );
};

export default SetupPath;
